import $axios from '@martyrs/src/modules/core/views/utils/axios-instance.js';
import { setError } from '@martyrs/src/modules/core/views/store/core.store.js';
import { reactive } from 'vue';

const state = reactive({
  list: [],
  plans: [],
  loading: false,

  // Текущая подписка юзера (из GET /api/subscriptions/current). Все поля ниже
  // считает бэк, фронт тупо хранит. `limits` — feature-flags из plan.metadata.limits,
  // компоненты читают конкретно: state.limits?.ai_hr_dialogs / .applies_per_day / etc.
  current: null,
  limits: null,
  currentLoaded: false,
  hasAccess: false,
  isTrial: false,
  hasPaidAccess: false,
  isTrialExpired: false,
});

const actions = {
  async subscribe({ planId, provider, returnUrl }) {
    state.loading = true;
    try {
      const response = await $axios.post('/api/subscriptions/create', {
        planId,
        provider,
        returnUrl,
      }, {
        headers: { 'Idempotency-Key': crypto.randomUUID() },
      });
      return response.data;
    } finally {
      state.loading = false;
    }
  },

  async cancel(subscriptionId, { immediate = false } = {}) {
    const response = await $axios.post(`/api/subscriptions/${subscriptionId}/cancel`, { immediate });
    return response.data;
  },

  async pause(subscriptionId) {
    const response = await $axios.post(`/api/subscriptions/${subscriptionId}/pause`);
    return response.data;
  },

  async resume(subscriptionId) {
    const response = await $axios.post(`/api/subscriptions/${subscriptionId}/resume`);
    return response.data;
  },

  async listSubscriptions() {
    state.loading = true;
    try {
      const response = await $axios.get('/api/subscriptions');
      state.list = response.data;
      return response.data;
    } finally {
      state.loading = false;
    }
  },

  async listPlans() {
    const response = await $axios.get('/api/plans');
    state.plans = response.data;
    return response.data;
  },

  async getPlan(slugOrId) {
    const response = await $axios.get(`/api/plans/${slugOrId}`);
    return response.data;
  },

  async load({ reconcile } = {}) {
    if (state.currentLoaded && !reconcile) return;
    state.loading = true;
    try {
      const url = reconcile
        ? '/api/subscriptions/current?reconcile=1'
        : '/api/subscriptions/current';
      const { data } = await $axios.get(url);
      Object.assign(state, data);
      state.currentLoaded = true;
    } catch (err) {
      if (err?.response?.status !== 401) setError(err);
      state.current = null;
      state.limits = null;
      state.hasAccess = false;
      state.isTrial = false;
      state.hasPaidAccess = false;
      state.isTrialExpired = false;
      state.currentLoaded = true;
    } finally {
      state.loading = false;
    }
  },

  reset() {
    state.current = null;
    state.limits = null;
    state.hasAccess = false;
    state.isTrial = false;
    state.hasPaidAccess = false;
    state.isTrialExpired = false;
    state.currentLoaded = false;
  },
};

export { state, actions };
